import React from 'react'
import type { DialogProps } from '@paintscout/ui'
import { Button, Dialog, DialogContent, DialogTitle, DialogActions, Alert } from '@paintscout/ui'
import type { UpdateableArea, LabelsOption } from '@paintscout/util/builder'
import { updateArea, getArea } from '@paintscout/util/builder'

import type { OptionsDocument, QuoteDocument } from 'paintscout'
import AreaTotalsForm from './AreaTotalsForm'

export interface AreaTotalsDialogProps extends DialogProps {
  quote: QuoteDocument
  areaKey: string
  quoteLabel: LabelsOption
  options: OptionsDocument
  onConfirm: (quote: QuoteDocument) => any
  onCancel: () => any
}

export default function AreaTotalsDialog(props: AreaTotalsDialogProps) {
  const { onCancel, onConfirm, areaKey, options, quoteLabel, ...baseDialogProps } = props
  const [updatedQuote, setUpdatedQuote] = React.useState(props.quote)

  const area = getArea({ quote: updatedQuote, options, key: areaKey })

  function handleChange(ev: any, newArea: UpdateableArea) {
    setUpdatedQuote(updateArea({ quote: updatedQuote, options, area: newArea }))
  }

  function handleConfirm(ev: any) {
    ev.preventDefault()
    onConfirm(updatedQuote)
  }

  return (
    <Dialog open={open} maxWidth="md" fullWidth={true} {...baseDialogProps}>
      <DialogTitle>Adjust Totals</DialogTitle>
      <DialogContent>
        <form id="area-totals" onSubmit={handleConfirm}>
          <AreaTotalsForm area={area} onChange={handleChange} />
        </form>
      </DialogContent>
      <Alert
        content={`Note: Overriding values here may overwrite previous custom rates for ${quoteLabel.substrate.plural} in this area. ${quoteLabel.quote.value} hourly rate will be used to calculate total. `}
        severity={'warning'}
      />
      <DialogActions
        leftButton={
          <Button variant="textNoPadding" onClick={onCancel}>
            Cancel
          </Button>
        }
      >
        <Button type="submit" form="area-totals">
          Done
        </Button>
      </DialogActions>
    </Dialog>
  )
}
